// extracted by mini-css-extract-plugin
export default {"date-picker":"styles_date-picker__YWWy8"};